export default __webpack_public_path__ + "static/media/DBIA.df368b93.png";